export default __webpack_public_path__ + "static/media/account.71bff070.svg";